// extracted by mini-css-extract-plugin
export default {"customModal":"custom-modal_customModal__S0WCQ","content":"custom-modal_content__XKJLC","title":"custom-modal_title__axAxe"};